import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [5, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/03/29/principle/virtual-scene.svg`,
                  },
                },
                styles: {
                  padding: "6% 3% 0",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "The virtual scene contains a source, a receiver and geometrical information including material databases. Especially the source and receiver translation and rotation are important to notice.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "12px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  padding: "2% 5% 0",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
